export default __webpack_public_path__ + "static/media/main.3e2c033f.jpg";